import { FunctionComponent, useEffect, useRef } from 'react';

import {
  AutoplayControlConnected,
  BetOnAllControlConnected,
  ChipStack,
  L12nText,
  ReBetControlConnected,
  StatisticsControlConnected,
  UndoControlConnected,
  useBetSlice,
  useGameStateSlice,
  useModifiers,
} from '@pp/core';

import { useAllLimitConnected } from '../hooks/useAllLimitConnected';
import { useBetOnAllCallbackConnected } from '../hooks/useBetOnAllCallbackConnected';
import { MWGameGridObserver } from '../MWGameGridObserver';
import styles from './wideChipStackControls.module.css';

export interface WideChipStackControlsConnectedProps {}

export const WideChipStackControlsConnected: FunctionComponent<WideChipStackControlsConnectedProps> = () => {
  const isBetsOpenStatus = useGameStateSlice.isBetsOpenStatus();
  const betOnAll = useBetOnAllCallbackConnected();
  const multipleLimitTooltip = useAllLimitConnected();
  const wideChipStackRef = useRef<HTMLDivElement>(null);
  const wideChipStackControlWingRef = useRef<HTMLDivElement>(null);
  const balance = useGameStateSlice.getDeductibleBalance();
  const isLowBalance = useBetSlice.isLowBalance(balance);
  useEffect(() => {
    MWGameGridObserver.addMeasurer('wideChipStack', () => {
      return {
        wideChipStackHeight: wideChipStackRef.current?.offsetHeight || null,
        wideChipStackWidth: wideChipStackRef.current?.offsetWidth || null,
        wideChipStackControlWingHeight: wideChipStackControlWingRef.current?.offsetHeight || null,
        wideChipStackControlWingBottom: wideChipStackControlWingRef.current?.getBoundingClientRect().bottom || null,
      };
    });
  }, []);

  const mods = useModifiers(styles, 'wideChipStackControls', { open: isBetsOpenStatus && !isLowBalance });

  return (
    <div className={`${styles.wideChipStackControls} ${mods}`}>
      <div className={styles.wideChipStackControls__wing} ref={wideChipStackControlWingRef}>
        <div
          className={`${styles.wideChipStackControls__betOnAll} ${styles.wideChipStackControls__betOnAll_full} ${styles.wideChipStackControls__collapsing}`}
        >
          <BetOnAllControlConnected
            tooltip={multipleLimitTooltip}
            label={<L12nText tk="BETONALL" />}
            onClick={betOnAll}
          />
        </div>
        <div
          className={`${styles.wideChipStackControls__betOnAll} ${styles.wideChipStackControls__betOnAll_compact} ${styles.wideChipStackControls__collapsing}`}
        >
          <BetOnAllControlConnected tooltip={multipleLimitTooltip} onClick={betOnAll} />
        </div>
      </div>

      <div className={styles.wideChipStackControls__row} ref={wideChipStackRef}>
        <div className={styles.wideChipStackControls__statistics}>
          <StatisticsControlConnected />
        </div>
        <UndoControlConnected className={styles.wideChipStackControls__collapsing} />
        <div className={`${styles.wideChipStackControls__collapsing} ${styles.wideChipStackControls__chipStack}`}>
          <ChipStack.Bar />
        </div>
        <ReBetControlConnected tooltip={multipleLimitTooltip} className={styles.wideChipStackControls__collapsing} />
      </div>
      <div className={` ${styles.wideChipStackControls__wing}`}>
        <div
          className={`${styles.wideChipStackControls__autoplay} ${styles.wideChipStackControls__autoplay_full} ${
            !isBetsOpenStatus && styles.wideChipStackControls__autoplay_full_hide
          }`}
        >
          <AutoplayControlConnected label={<L12nText tk="AUTOPLAY" />} />
        </div>
        <div
          className={`${styles.wideChipStackControls__autoplay} ${styles.wideChipStackControls__autoplay_compact} ${
            !isBetsOpenStatus && styles.wideChipStackControls__autoplay_display_compact
          }`}
        >
          <AutoplayControlConnected />
        </div>
      </div>
    </div>
  );
};
